/// <amd-module name="Agile/Common/Routes/AgileHubUrlUtils" />
import { IVssLocationService } from "VSS/Platform/Location";
import { IVssPageContext } from "VSS/Platform/Context";
import { RouteParameters } from "Constants/RoutingConstants";

/**
 * Get a URL to a agile hub
 */
export function getAgileHubContentUrl(pageContext: IVssPageContext, projectName: string, teamName: string, routeId: string): string {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");

    const routeValues: { [key: string]: string } = {
        [RouteParameters.Project]: projectName,
        [RouteParameters.TeamName]: teamName
    };

    return locationService.routeUrl(routeId, routeValues);
}

/**
 * Get a URL to a agile hub. Does not include team (i.e. directory route)
 */
export function getAgileHubRootUrl(pageContext: IVssPageContext, projectName: string, routeId: string): string {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");

    const routeValues: { [key: string]: string } = {
        [RouteParameters.Project]: projectName
    };

    return locationService.routeUrl(routeId, routeValues);
}

/**
 * Get a URL to a agile hub pivot
 */
export function getAgileHubPivotContentUrl(
    pageContext: IVssPageContext,
    projectName: string,
    teamName: string,
    pivot: string,
    routeId: string,
    backlog?: string
): string {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");

    const routeValues: { [key: string]: string } = {
        [RouteParameters.Project]: projectName,
        [RouteParameters.TeamName]: teamName,
        [RouteParameters.Pivot]: pivot
    };

    if (backlog) {
        routeValues[RouteParameters.BacklogLevel] = backlog;
    }

    return locationService.routeUrl(routeId, routeValues);
}